import { StorageKey } from './enum.js';
export const checkStorage = (storageKey) => {
    const storage = storageKey === 'sessionStorage' ? window.sessionStorage : window.localStorage;
    const storedRefreshToken = storage.getItem(StorageKey.RefreshToken);
    const storedIdToken = storage.getItem(StorageKey.IdToken);
    return {
        storedRefreshToken,
        storedIdToken,
    };
};
export const loadRefreshTokenStorageFromParams = (storageType) => {
    const params = getParams();
    if (params.refresh_token && params.refresh_token_expires_on && params.refresh_token_expires_in) {
        const refreshTokenStorage = {
            refreshToken: params.refresh_token,
            expiresOn: parseInt(params.refresh_token_expires_on),
            expiresIn: parseInt(params.refresh_token_expires_in),
        };
        const storage = storageType === 'sessionStorage' ? window.sessionStorage : window.localStorage;
        storage.setItem(StorageKey.RefreshToken, JSON.stringify(refreshTokenStorage));
        storage.removeItem(StorageKey.IdToken);
        return refreshTokenStorage;
    }
    return null;
};
export const isValidTokens = (accessTokenStorage, refreshTokenStorage, idTokenStorage) => {
    const currentTimeStamp = new Date().getTime() / 1000;
    const expectedTimestamp = currentTimeStamp + 5;
    const hasValidAccessToken = !!(accessTokenStorage === null || accessTokenStorage === void 0 ? void 0 : accessTokenStorage.accessToken) &&
        accessTokenStorage.expiresOn &&
        expectedTimestamp < accessTokenStorage.expiresOn;
    const hasValidRefreshToken = !!(refreshTokenStorage === null || refreshTokenStorage === void 0 ? void 0 : refreshTokenStorage.refreshToken) &&
        refreshTokenStorage.expiresOn &&
        expectedTimestamp < refreshTokenStorage.expiresOn;
    const hasValidIdToken = !!(idTokenStorage === null || idTokenStorage === void 0 ? void 0 : idTokenStorage.idToken) &&
        idTokenStorage.account &&
        idTokenStorage.account.exp &&
        expectedTimestamp < idTokenStorage.account.exp;
    return {
        hasValidAccessToken,
        hasValidRefreshToken,
        hasValidIdToken,
    };
};
export var ErrorType;
(function (ErrorType) {
    ErrorType["Unauthorized"] = "Unauthorized";
    ErrorType["FetchUserInfo"] = "Failed to fetch user info";
    ErrorType["ExchangeAccessToken"] = "Failed to exchange access token";
    ErrorType["ObtainAccessToken"] = "Can not obtain access token";
    ErrorType["InvalidRefreshToken"] = "Invalid refresh token";
    ErrorType["LoginFailed"] = "Unable to initial login flow";
    ErrorType["LogoutFailed"] = "Unable to initial logout flow";
    ErrorType["Unknown"] = "An error occurs.";
})(ErrorType || (ErrorType = {}));
export const handleError = (e, fallback) => {
    if (String(e).includes('Unauthorized'))
        return ErrorType.Unauthorized;
    if (fallback)
        return fallback;
    return ErrorType.Unknown;
};
export const getParams = () => {
    const searchString = window.location.search.substring(1);
    const paramsString = searchString.split('&');
    const params = searchString
        ? paramsString.reduce((params, paramString) => {
            const [key, value] = paramString.split('=');
            return Object.assign(Object.assign({}, params), { [key]: value });
        }, {})
        : {};
    return params;
};
